/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  PlaythroughStats,
  PlaythroughStatsFromJSON,
  PlaythroughStatsFromJSONTyped,
  PlaythroughStatsToJSON,
} from './PlaythroughStats'

/**
 *
 * @export
 * @interface UserRunsData
 */
export interface UserRunsData {
  /**
   *
   * @type {string}
   * @memberof UserRunsData
   */
  endedAt: string
  /**
   *
   * @type {number}
   * @memberof UserRunsData
   */
  score: number
  /**
   *
   * @type {PlaythroughStats}
   * @memberof UserRunsData
   */
  stats: PlaythroughStats
}

export function UserRunsDataFromJSON(json: any): UserRunsData {
  return UserRunsDataFromJSONTyped(json, false)
}

export function UserRunsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRunsData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    endedAt: json['endedAt'],
    score: json['score'],
    stats: PlaythroughStatsFromJSON(json['stats']),
  }
}

export function UserRunsDataToJSON(value?: UserRunsData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    endedAt: value.endedAt,
    score: value.score,
    stats: PlaythroughStatsToJSON(value.stats),
  }
}
